import PhoneRingingInHand from '../src/PhoneRingingInHand';
export default PhoneRingingInHand;
